<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { Markdown } from 'vue-stream-markdown'
import { cn } from './utils'

interface Props {
  content: string
  variant?: 'assistant' | 'user' | 'reasoning'
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'assistant',
})

const controls = {
  table: {
    fullscreen: false,
  },
}
</script>

<template>
  <Markdown
    :content="props.content"
    :controls="controls"
    :class="
      cn(
        'agent-markdown size-full [&>*:first-child]:!mt-0 [&>*:last-child]:!mb-0',
        `agent-markdown-${props.variant}`,
        props.class
      )
    "
    v-bind="$attrs"
  />
</template>
